import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import WireCaption from './wire-caption';
import WireTitle from './wire-title';

const Container = styled.section`
  ${props => (props.theme.isMobile ? `
    margin: 0 -20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 12px;
    padding-bottom: 7px;
  ` : `
    margin: 0px -26px;
    padding-left: 26px;
    padding-right: 26px;
    padding-bottom: 15px;
  `)};
  border-radius: 0px;
  border: none;

  .wire__summary > .clampped-summary {
    em {
      font-style: normal;
      font-weight: ${props => props.theme.fontWeightHeavy};
    }

    .show-more {
      font-weight: ${props => props.theme.fontWeightHeavy};
    }
  }
`;

const CaptionRow = styled.div`
  display: flex;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  ${props => (props.theme.isMobile ? `
    font-size: 10px;
    line-height: 18px;
    margin-bottom: 8px;
  ` : `
    font-size: 12px;
    line-height: 12px;
  `)};
  text-transform: uppercase;
  justify-content: space-between;
  align-content: center;

  > span.main {
    color: ${props => props.theme.primaryColor};
  }
  > span.secondary {
    color: ${props => props.theme.secondaryColor};
  }
`;

const DraftRow = styled.div`
  background: #232D3F;
  color: #FFFFFF;
  width: 54px;
  height: 19px;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  padding: 2px 0;
  font-weight: ${props => props.theme.fontWeightHeavy};
  border-radius: 6px;
  margin-bottom: ${props => (props.theme.isMobile ? 8 : 0)}px;
`;

const LastSaved = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-size: ${props => (props.theme.isMobile ? 13 : 15)}px;
`;

const Line = styled.div`
  margin-top: 6px;
  width: 100%;
  height: 0px;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  display: inline-block;
`;

export default function Wire({ wire }) {
  return (
    <Container>
      {!!wire.firstPublishedAt && (
        <CaptionRow>
          <span className="main">
            <WireCaption wire={wire} />
          </span>
        </CaptionRow>
      )}
      {!wire.firstPublishedAt && <DraftRow>Draft</DraftRow>}
      <WireTitle wire={wire} />
      {!wire.firstPublishedAt && !!wire.updatedAt && (
        <LastSaved>
          {`Last saved on ${moment(wire.updatedAt).format('MMMM Do YYYY @ h:mm:ss a')}`}
        </LastSaved>
      )}
      <Line />
    </Container>
  );
}

Wire.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string,
    firstPublishedAt: PropTypes.string,
    publishedAt: PropTypes.string,
    updatedAt: PropTypes.string,
    isSponsored: PropTypes.bool.isRequired,
    userId: PropTypes.number.isRequired,
    editorsPicked: PropTypes.bool,
    // This is covering draft wire as well. Optional.
    featuredCount: PropTypes.number,
    ownedByCurrentUser: PropTypes.bool.isRequired,
    profilePictureUrl: PropTypes.string,
    category: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    series: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
    profile: PropTypes.shape({
      profilePictureUrl: PropTypes.string,
      name: PropTypes.string,
      organisation: PropTypes.string,
    }),
  }).isRequired,
};
